export const environment = {
  production: true,
  OAUTH: true,
  OAUTH_LOG_LEVEL: -1, // use 4 for full debug
  CLOUD_INSTANCE_ID: "https://login.microsoftonline.com",
  TENENT_ID: "330bb465-3c11-4592-9e1c-607418bcea05",
  APPLICATION_ID: "d282db73-62a1-4866-a0f3-9b8fa8431d81",
  REDIRECT_URI: "https://datastore.ppp.saker.solutions/splash",
  WEB_API_ENDPOINT: "https://datastore.ppp.rack.saker.solutions",
  WEB_API_SCOPES: ["api://d282db73-62a1-4866-a0f3-9b8fa8431d81/global"],
  GRAPH_ENDPOINT: "https://graph.microsoft.com/v1.0/me",
  GRAPH_SCOPES: ["user.read"]
};
